import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	width: 24,
	height: 24,
	fill: "none",
	strokeWidth: 1.5,
	stroke: "#A8071A",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M12 23.25c6.213 0 11.25-5.037 11.25-11.25S18.213.75 12 .75.75 5.787.75 12 5.787 23.25 12 23.25z" }),
		/* @__PURE__ */ _jsxs("g", {
			strokeLinecap: "round",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M12 16.5c-.207 0-.375.168-.375.375s.168.375.375.375.375-.168.375-.375-.168-.375-.375-.375h0",
				strokeLinejoin: "round"
			}), /* @__PURE__ */ _jsx("path", { d: "M12 13.5V5.25" })]
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2024%2024%22%20width%3D%2224%22%20height%3D%2224%22%20fill%3D%22none%22%20stroke-width%3D%221.5%22%20stroke%3D%22%23A8071A%22%3E%3Cpath%20d%3D%22M12%2023.25c6.213%200%2011.25-5.037%2011.25-11.25S18.213.75%2012%20.75.75%205.787.75%2012%205.787%2023.25%2012%2023.25z%22%2F%3E%3Cg%20stroke-linecap%3D%22round%22%3E%3Cpath%20d%3D%22M12%2016.5c-.207%200-.375.168-.375.375s.168.375.375.375.375-.168.375-.375-.168-.375-.375-.375h0%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M12%2013.5V5.25%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E%20";
